import { getConfigName } from "@helpers/funciones";
import { Box, Typography } from "@mui/material";
import OfertaArrendamientoFinbe from "@pages/producto/arrendamiento/OfertaArrendamientoFinbe";
import { OfertaArrendamientoLanitAuto } from "@pages/producto/arrendamiento/OfertaArrendamientoLanitAuto";

const ofertasComponent: Record<string, React.FC> = {
  lanitauto: OfertaArrendamientoLanitAuto,
  finbe: OfertaArrendamientoFinbe,
};
const OfertaArrendamiento = () => {
  const configName = getConfigName(window.location.href);

  const Component = ofertasComponent[configName];

  if (!Component) {
    return (
      <Box
        sx={{
          p: 2,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="tofu_title">Por el momento no contamos con una oferta disponible para esta configuración.</Typography>
      </Box>
    );
  }

  return <Component />;
};

export default OfertaArrendamiento;
